const sharetribeSdk = require('sharetribe-flex-sdk');
const sdk = sharetribeSdk.createInstance({
  clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID,
});

export const getLatestListings = () => {
  return sdk.ownListings
    .query({})
    .then(res => {
      const listings = res.data.data;
      return listings?.[0];
    })
    .catch(e => console.log(e));
};
